import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    label: {
      default: 'c-brand-1',
      shared: 'body-4'
    }
  }
} satisfies RecursivePartial<VfConfig['switch']>
